import { type DependencyList, useMemo, useRef } from 'react';

import { isEqual } from 'lodash-es';

export const useDeepEqualMemo: typeof useMemo = (fn, deps) => {
  const ref = useRef<DependencyList | undefined>(undefined);
  const signalRef = useRef<number>(0);

  if (!isEqual(deps, ref.current)) {
    ref.current = deps;
    signalRef.current += 1;
  }

  /* eslint-disable-next-line @eslint-react/exhaustive-deps */
  return useMemo(fn, [signalRef.current]);
};
